// chat-selection.svelte.ts — sidebar multi-select for bulk actions (SAY-1820).
// One selection across the Chats list, folders and the Trash: the bulk bar
// derives what it can do from which rows (live vs. trashed) are selected.

import { SvelteSet } from 'svelte/reactivity';

// A plain Set inside $state is NOT deep-reactive in Svelte 5 — SvelteSet is.
const selected = new SvelteSet<string>();
let active = $state(false);

export function isSelectionMode(): boolean {
	return active;
}

export function setSelectionMode(on: boolean): void {
	active = on;
	if (!on) selected.clear();
}

export function selectedIds(): SvelteSet<string> {
	return selected;
}

export function isSelected(id: string): boolean {
	return selected.has(id);
}

export function toggleSelected(id: string, on?: boolean): void {
	const next = on ?? !selected.has(id);
	if (next) selected.add(id);
	else selected.delete(id);
}

export function selectMany(ids: string[], on: boolean): void {
	for (const id of ids) {
		if (on) selected.add(id);
		else selected.delete(id);
	}
}

export function clearSelection(): void {
	selected.clear();
}
